import React, { FC } from 'react';
import { ReactComponent as Add } from 'assets/icons/Add-circle.svg';
import styles from './emptyStateComponent.module.scss';

interface EmptyStateComponentProps {
  title: string;
  subTitle: string;
  subHeading?: string;
}

const EmptyStateComponent: FC<EmptyStateComponentProps> = ({
  title,
  subTitle,
  subHeading,
}) => {
  return (
    <div className={styles.container}>
      <div>
        <Add className={styles.addIconWrapper} />
      </div>
      <div className={styles.title}>{title}</div>
      {subHeading && <div className={styles.subHeading}>{subHeading}</div>}
      <div className={styles.subTitle}>{subTitle}</div>
    </div>
  );
};

export default EmptyStateComponent;
